<template>
  <div>
    <!-- TEXT -->
    <div v-if="value.type == 'text'">
      <v-text-field v-model="model.value" :label="value.label" type="text" clearable />
    </div>

    <!-- NUMERIC -->
    <div v-if="value.type == 'numeric'">
      <v-text-field v-model="model.value" :label="value.label" type="numeric" clearable />
    </div>
    <!-- BOOLEAN -->
    <div v-if="value.type == 'boolean'">
      <v-checkbox v-model="model.value" :label="value.label"></v-checkbox>
    </div>

    <!-- COMBO -->
    <div v-if="value.type == 'combo'">
      <v-select v-model="model.value" :label="value.label" :items="value.combo" clearable></v-select>
    </div>

    <!-- DATETIME -->
    <div v-if="value.type == 'datetime'">
      <datetime-picker-dialog
  
        dateFormat="dd/MM/yy"
        :label="value.label"
        v-model="model.value"
      ></datetime-picker-dialog>
      <!-- <v-datetime-picker
        :clearText="$t('cancel')"
        :okText="$t('confirm')"
        dateFormat="dd/MM/yy"
        :label="value.label"
        v-model="model.value"
      ></v-datetime-picker>-->
    </div>

    <div v-if="value.type == 'entity'">
      <auto-complete-entity
        :ref="value.prop"
        v-model="model.value"
        :entityApi="value.prop"
        :itemText="value.propertyText.toLowerCase()"
        itemValue="id"
        :label="value.label"
        prependIcon="mdi-find-replace"
      />
    </div>
    <!-- <div v-if="value.type == 'datetime'">
      <datetime
        format="dd/MM/yyyy HH:mm"
        v-model="model.value"
        type="datetime"
        :title="value.label"
      >
        <label slot="before">{{value.label}} :</label>
      </datetime>
    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    value: {}
  },
  data() {
    return {
      model: {
        value: ""
      }
    };
  },
  watch: {
    model() {
      this.$emit("input", this.model);
    },
    value() {
      this.model = this.getModelDefault();
    }
  },
  methods: {
    getValue() {
      this.createModel();
      return this.model;
    },

    createModel() {
      this.model.label = this.value.label;
      this.model.fieldFilter = this.value.fieldFilter;
      this.model.prop = this.value.prop;
      this.model.isRequired = this.value.isRequired;
      if (this.value.type == "boolean" && this.model.value == "")
        this.model.value = false;
    },
    getModelDefault() {
      return {
        prop: "",
        fieldFilter: "",
        value: ""
      };
    }
  },
  mounted() {
    if (this.value.typeData == "boolean" && this.model.value == "")
      this.model.value = false;
  },
  created() {
    this.$root.$on("clean", () => {
      this.model = this.getModelDefault();
    });
  }
};
</script>

<style >
.vdatetime-input {
  background-color: beige;
  border-radius: 25px;
  background: beige;
  padding: 10px;
  width: 170px;
}
</style>